import './App.css';
import {fsiTheme} from "./theme";
import {BrowserRouter, Route, Routes, useLocation} from "react-router";
import {HomePage} from "./pages/HomePage";
import {TeamPage} from "./pages/TeamPage";
import {ContactPage} from "./pages/ContactPage";
import {Navbar, NavItem, Offcanvas} from "react-bootstrap";
import {useEffect, useState} from "react";
import {Button} from "./components/Button";
import "bootstrap-icons/font/bootstrap-icons.css";

export function App() {
    return(
        <>
            <BrowserRouter>
                <Routes>
                    <Route path={"/"} element={<HomePage/>}/>
                    <Route path={"/team"} element={<TeamPage/>}/>
                    <Route path={"/contact"} element={<ContactPage/>}/>
                </Routes>
            </BrowserRouter>
        </>
    )
}



export function Page({children}){
    const style = {
        backgroundColor: fsiTheme.background,
        minHeight: '100vh',
        overflowX:'auto',
        overflowY: 'auto',
        minWidth: 300,
        fontSize: '1.2em',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    }
    useEffect(() => {
       document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant", // Optional if you want to skip the scrolling animation
        })
    }, []);
    return(
        <div style ={style}>
            <Header/>
            <Body>
                {children}
            </Body>
            <Footer/>
        </div>
    )
}

export function Header(){
    const style = {
        height: 80,
        backgroundColor: fsiTheme.header,
        boxShadow: `5px 6px ${fsiTheme.headerShadow}`,
        width: "calc(100% - 30px)",
        marginTop: 10,
        borderRadius: 10,
        display: 'flex',
        justifyContent: 'space-between',
    }
    const [show, setShow] = useState(false)
    const [shrinkLogo, setShrinkLogo] = useState(window.innerWidth < 500)
    const breakHandler = () =>{
        if(window.innerWidth < 500){
            setShrinkLogo(true)
        } else{
            setShrinkLogo(false)
        }
    }
    useEffect(() => {
        window.addEventListener('resize', breakHandler)
        return () => window.removeEventListener('resize', breakHandler)
    }, []);
    return (
        <div style = {{width: '100%', display: 'flex', justifyContent:'center', fontSize: '0.85em'}}>
            <div style={style}>
                <a href={'/'}>
                    <img src="/images/FULLSTACK SOFTWARE INNOVATIONS.png"
                         alt={"Fullstack Software Innovations (Logo)"}
                         style={{marginTop: shrinkLogo ? 10 : 5, marginLeft: 5, height: shrinkLogo ? 60 : 75}}/>

                </a>
                <Button onClick={() => setShow(true)} color = {fsiTheme.header}>
                    <i className="bi bi-list" style={{fontSize: '1.5em'}}/>
                </Button>
            </div>


            <Offcanvas
                show={show}
                placement={'end'}
                onHide={()=>setShow(false)}
                style = {{backgroundColor: fsiTheme.background}}
            >

                <Offcanvas.Header
                    closeButton
                    style={{
                        backgroundColor: fsiTheme.header,
                        color: fsiTheme.buttonText,
                        fontSize: '1.5em'
                    }}>
                    <img src="/images/FULLSTACK SOFTWARE INNOVATIONS.png"
                         alt={"Fullstack Software Innovations (Logo)"}
                         style={{marginTop: shrinkLogo ? 10 : 5, marginLeft: 5, height: 75, cursor: "pointer"}}
                         onClick={()=>setShow(false)}
                    />

                </Offcanvas.Header>
                <Offcanvas.Body
                    style={{
                        fontSize: '1.5em'
                    }}>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 20}}>

                    <a href={'/'} style={{color: 'black', textDecoration: 'none'}}>
                            <i className="bi bi-house-door-fill"> </i>
                            Home
                        </a>

                        <a href={'/team'} style={{color: 'black', textDecoration: 'none'}}>
                            <i className="bi-file-person-fill"> </i>
                            Meet the team
                        </a>

                        <a href={'/contact'} style={{color: 'black', textDecoration: 'none'}}>
                            <i className="bi bi-envelope-paper-heart-fill"> </i>
                            Contact us
                        </a>
                    </div>

                </Offcanvas.Body>
            </Offcanvas>
        </div>

    )

}

export function Body({children}) {
    return (
        <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            width: "100%",
            marginTop: 20,
            paddingBottom: 20
        }}>
            <div style={{width: "85%", textAlign:'center'}}>
                {children}
            </div>
        </div>
    )
}

export function Footer(){
    return(
        <div
            style={{
                height: 60,
                backgroundColor: fsiTheme.footer,
                padding: 10,
                fontSize:'.75em'
            }}
        >
            Site Design / Logo © 2026 Fullstack Software Innovations
        </div>
    )
}

export function Separator(){
    return (
        <p style={{
            borderBottom: `3px solid ${fsiTheme.separator}`,
            borderTop: `3px solid ${fsiTheme.separator}`,
            margin: '30px 0 50px',
            borderRadius: 5
        }}/>

    )
}
